import React from "react";
import { useTranslation } from "react-i18next";
import { Label } from "reactstrap";
import Select from "./Select";

export const SelectUnit = ({ options = [], value, onChange, ...props }) => {
  const { t } = useTranslation();

  return (
    <Label {...props}>
      <span className="mr-2 font-weight-bold">
        {t("global.consumption.unit")}
      </span>

      <Select
        value={options.find((o) => o.value === value)}
        options={options}
        onChange={(option) => {
          if (option) onChange(option.value);
        }}
        width={200}
        fontSize={12}
        bordered
      />
    </Label>
  );
};
